import { Stat, StatGroup, StatLabel, StatNumber } from "@chakra-ui/react";
import { useCreditFacilitySummaryRetrieveSuspense } from "gen/endpoints/credit-facility/credit-facility";
import { useCreditFacilityBorrowingBaseSummaryTableRetrieveSuspense } from "gen/endpoints/credit-facility-borrowing-base-group-summary-table/credit-facility-borrowing-base-group-summary-table";
import { useTranslation } from "react-i18next";
import { TableBoxBody } from "shared/components/table/box/TableBoxBody";
import { TableBoxStats } from "shared/components/table/box/TableBoxStats";
import { DataTable } from "shared/components/table/data/DataTable";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";
import { formatMoney } from "shared/utils/MoneyUtils";

export const BorrowingBaseSummaryTableBody: React.FC<{
  creditFacilityId: string;
  fundFamilyEventId?: string;
  effectiveDate?: string;
}> = ({ creditFacilityId, fundFamilyEventId, effectiveDate }) => {
  const { fundFamilyId } = useRequiredStringParams();
  const { t } = useTranslation(["creditFacility"]);
  const { data: summaryData } = useCreditFacilitySummaryRetrieveSuspense(
    fundFamilyId,
    creditFacilityId,
    {
      fund_family_event_id: fundFamilyEventId,
      version_date: effectiveDate,
    },
  );
  const { data: tableData } =
    useCreditFacilityBorrowingBaseSummaryTableRetrieveSuspense(
      fundFamilyId,
      creditFacilityId,
      {
        fund_family_event_id: fundFamilyEventId,
        version_date: effectiveDate,
      },
    );
  const { borrowing_base_amount, available_amount } = summaryData;

  return (
    <>
      <TableBoxStats>
        <StatGroup>
          <Stat>
            <StatLabel>
              {t("creditFacility:borrowingBase.summary.totalBorrowingAmount")}
            </StatLabel>
            <StatNumber fontSize="20px">
              {formatMoney(borrowing_base_amount)}
            </StatNumber>
          </Stat>
          <Stat>
            <StatLabel>
              {t(
                "creditFacility:borrowingBase.summary.availableBorrowingAmount",
              )}
            </StatLabel>
            <StatNumber fontSize="20px">
              {formatMoney(available_amount)}
            </StatNumber>
          </Stat>
        </StatGroup>
      </TableBoxStats>
      <TableBoxBody>
        <DataTable data={tableData} />
      </TableBoxBody>
    </>
  );
};
